{% block sw_cms_element_dvsn_form_builder_preview %}
    <div class="sw-cms-element-preview-dvsn-form-builder">
        <h2>Lorem ipsum dolor sit amet</h2>
        <hr class="sw-cms-element-preview-dvsn-form-builder-hr">

        <div class="sw-cms-element-preview-dvsn-form-builder-grid-container-1-1">
            <div class="sw-cms-element-preview-dvsn-form-builder-placeholder"></div>
            <div></div>
        </div>

        <div class="sw-cms-element-preview-dvsn-form-builder-grid-container-1-1">
            <div class="sw-cms-element-preview-dvsn-form-builder-placeholder"></div>
            <div class="sw-cms-element-preview-dvsn-form-builder-placeholder"></div>
        </div>

        <div class="sw-cms-element-preview-dvsn-form-builder-placeholder"></div>
        <div class="sw-cms-element-preview-dvsn-form-builder-placeholder"></div>

        <div class="sw-cms-element-preview-dvsn-form-builder-button">
            <button>Lorem ipsum</button>
        </div>
    </div>
{% endblock %}